import React, { useState, useEffect, useMemo } from "react";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import axios from "axios";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";

const IndentNoteEdit = () => {
   useAuthRedirect();
  const { indentNo } = useParams();
  const branch = localStorage.getItem("branch");
  const navigate = useNavigate();
  
  const [deptList, setDeptList] = useState([]);
  const [indentView, setIndentView] = useState({ dept: "", remarks: "" });
  const [data, setData] = useState([]);

  
                //✅ Permission checks (safe even if perms not yet loaded; will be false)
                const canEdit = hasPermission("Store Requisition", "edit");
                const canVehicle = hasPermission("Hire Vehicle Registration", "entry");
                /////////////////////////////////////////////////////////////
    

  

useEffect(() => {
  const fetchAllIndentData = async () => {
    Swal.fire({
      title: "Fetching Indent Data...",
      html: `
        <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
          <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
        </div>
        <p style="margin-top: 10px; font-size: 14px;">Please wait while data is loading...</p>
      `,
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => {
        if (!document.getElementById("progressBarStyle")) {
          const style = document.createElement("style");
          style.id = "progressBarStyle";
          style.innerHTML = `
            @keyframes progressBar {
              0% { width: 0% }
              50% { width: 100% }
              100% { width: 0% }
            }
          `;
          document.head.appendChild(style);
        }
      }
    });

    try {
      const [headerRes, itemsRes, deptRes] = await Promise.all([
        axios.get(`https://rfs2.infraconsoft.net.in/api/storeReq_detailsHeader?indentNo=${indentNo}&branch=${branch}`),
        axios.get(`https://rfs2.infraconsoft.net.in/api/storeReq_bottomDetails?indentNo=${indentNo}&branch=${branch}`),
        axios.get(`https://rfs2.infraconsoft.net.in/api/storeReq_department?branch_code=${branch}`)
      ]);

      // Header
      if (headerRes.data.headerDetails?.length > 0) {
        const header = headerRes.data.headerDetails[0];
        setIndentView({
          dept: header.departmentmaster_code || "",
          remarks: header.indentHeader_remarks || "",
          indentDate: header.indentHeader_date || "N/A",
          supervisor: header.indentHeader_supervisorcode || "N/A",
        });
      }

      // Bottom Items
      setData(itemsRes.data.bottomDetails || []);

      // Department List
      setDeptList(deptRes.data.dept || []);

    } catch (error) {
      console.error("Error fetching indent data:", error);
    } finally {
      Swal.close();
    }
  };

  {canEdit && (
  fetchAllIndentData()
  )}
}, [indentNo, branch]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setIndentView((prev) => ({ ...prev, [name]: value }));
  };

  const handleRowChange = (index, field, value) => {
    setData((prevData) => prevData.map((item, i) => (i === index ? { ...item, [field]: value } : item)));
  };

 const handleSubmit = async (e) => {
  e.preventDefault();

  for (let item of data) {
    // quantity check
    if (!item.indentDetail_quantity || isNaN(item.indentDetail_quantity) || Number(item.indentDetail_quantity) <= 0) {
      Swal.fire("Error", `Enter a valid positive quantity for item: ${item.itemmaster_name}`, "error");
      return;
    }

    // due date check
    if (!item.indentDetail_dueDate) {
      Swal.fire("Error", `Enter due date for item: ${item.itemmaster_name}`, "error");
      return;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0); // reset time for comparison
    const dueDate = new Date(item.indentDetail_dueDate);

    if (dueDate < today) {
      Swal.fire("Error", `Due date must be today or a future date for item: ${item.itemmaster_name}`, "error");
      return;
    }
  }

  try {
    const updatedData = {
      indentNumber: indentNo,
      branch,
      dept: indentView.dept,
      remarks: indentView.remarks,
      items: data.map((item) => ({
        itemmaster_code: item.indentDetail_itemCode,
        qty: item.indentDetail_quantity,
        duedate: item.indentDetail_dueDate,
      })),
    };

    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const response = await axios.put("https://rfs2.infraconsoft.net.in/api/updateIndent", updatedData);
    if (response.data.success) {
      Swal.fire("Success!", "Indent note updated successfully!", "success");
      navigate('/inventory/indentNoteView');
    } else {
      Swal.fire("Error", "Failed to update indent note", "error");
    }
  } catch (error) {
    console.error("Error updating indent note:", error);
    Swal.fire("Error", "Server error while updating", "error");
  }
};

  if (!canEdit) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
             <div className="back-div">
                    <h2 className="add-txt">Edit Stores Requisition Note</h2>
                    <Link to='/inventory/indentNoteView'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                    </div>
          <Time />
        </section>

        <div className="form-container">
          <form onSubmit={handleSubmit}>
          <div className="form-row">
              <div className="form-group">
                <label>Indent No :</label>
                <input type="text" name="indentNo" value={indentNo} readOnly/>
              </div>
              <div className="form-group">
                <label>Date :</label>
                <input
  type="text"
  name="endhrs"
  value={indentView.indentDate ? new Date(indentView.indentDate).toISOString().split("T")[0] : ""}
 readOnly
/>

              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Department:</label>
                <select name="dept" value={indentView.dept} onChange={handleInputChange}>
                  {deptList.map((item, index) => (
                    <option key={index} value={item.departmentmaster_code}>{item.departmentmaster_name}</option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>Supervisor Code :</label>
                <input type="text" value={indentView.supervisor} name="user"  readOnly/>
              </div>
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>Remarks:</label>
                <input type="text" name="remarks" value={indentView.remarks} onChange={handleInputChange} required />
              </div>
              <div className="form-group">
                <label></label>
                <input type="hidden" />
              </div>
            </div>

            <div className="content-table">
              <table>
                <thead>
                  <tr>
                  <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>Part No</th>
                    <th>UOM</th>
                     {canVehicle && (
                      <>
                    <th>Vehicle Code</th>
                    <th>Vehicle Number</th>
                    </>
                     )}
                    <th>Qty</th>
                    <th>Due Date</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                    data.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.indentDetail_itemCode}</td>
                        <td>{item.itemmaster_name}</td>
                        <td>{item.itemmaster_drawingNumber}</td>
                        <td>{item.itemmaster_uom}</td>
                        {canVehicle && (
                      <>
                        <td>{item.indentDetaill_VehicleCode}</td>
                        <td>{item.indentDetaill_VehicleNumber}</td>
                        </>
                        )}
                        <td>
                          <input type="number" value={item.indentDetail_quantity} onChange={(e) => handleRowChange(index, "indentDetail_quantity", e.target.value)} />
                        </td>
                        <td>
                          <input type="date" value={item.indentDetail_dueDate ? new Date(item.indentDetail_dueDate).toISOString().split("T")[0] : ""} onChange={(e) => handleRowChange(index, "indentDetail_dueDate", e.target.value)} />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4">No items</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default IndentNoteEdit;